import { keikkaBetoni_cacheName, cache_read, cache_write } from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";

export default class lujuusClass {
  constructor() {
    this.lujuusId = 0;
    this.lujuusSelite = "";
    this.lujuusSliderSortId = 0;
    this.lujuusText = "";
    this.lujuusShortCuts = "sss";
  }
  set(obj) {
    this.lujuusId = obj.lujuusId;
    this.lujuusSelite = obj.lujuusSelite.trim();
    this.lujuusSliderSortId = obj.lujuusSliderSortId;
    this.lujuusText = obj.lujuusText;
    this.lujuusShortCuts = obj.lujuusShortCuts;
  }
  get lujuusString() {
    {
      if (this.lujuusId === 8) return this.lujuusText || "C??/??";
      return this.lujuusSelite.trim();
    }
  }
}

export async function betoniLujuus_fetchList() {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/betoni/lujuus/list";
  const c = cache_read(keikkaBetoni_cacheName, fullUrl);
  if (c) return c;
  const response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "betoniLujuusClass.js:fetchBetoniLujuusList");
  if (!cResponse.success) return false;
  cache_write(keikkaBetoni_cacheName, fullUrl, cResponse.data, 0);
  const lujuudet = cResponse.data;
  for (let i = 0; i < lujuudet.length; i++)
    lujuudet[i].lujuusSelite = lujuudet[i].lujuusSelite?.trim();
  return lujuudet;
}
